import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        filePath: '<'
    },
    template: `
        <iframe src="{{ vm.src }}" class="pdf-iframe"
                style="width:100%;height:100vh;height:100dvh;border:0;overflow:none"
                allow="fullscreen" allowfullscreen/>
        <style>
            html { overflow: hidden; }
        </style>
    `
})
export default class {
    constructor ($sce, $window, $scope, TokenService) {
        this.$sce = $sce;
        this.$window = $window;
        this.$scope = $scope;
        this.TokenService = TokenService;
    }

    $onInit () {
        const language = this.TokenService.getActiveLanguage();
        const pdfViewerPath = `embedpdf/viewer.html?file=${encodeURIComponent(this.filePath)}&locale=${language}&modal=1`;
        this.src = this.$sce.trustAsResourceUrl(pdfViewerPath);

        this.onMessage = this.onMessage.bind(this);
        this.$window.addEventListener('message', this.onMessage);
        this.$scope.$on('$destroy', () => {
            this.$window.removeEventListener('message', this.onMessage);
            this.exitFullscreen();
        });
    }

    getSelfSrc () {
        return (this.$window.frameElement && this.$window.frameElement.getAttribute('src')) || this.finalUrl;
    }

    toggleFullscreen () {
        this.$window.parent.postMessage({ type: 'material-preview-fullscreen', src: this.getSelfSrc() }, '*');
    }

    exitFullscreen () {
        this.$window.parent.postMessage({ type: 'material-preview-exit', src: this.getSelfSrc() }, '*');
    }

    onMessage (e) {
        const d = e && e.data;
        if (!d || typeof d !== 'object') return;
        if (d.type === 'pdf-fullscreen-enter') {
            this.toggleFullscreen();
        }
        else if (d.type === 'pdf-fullscreen-exit') {
            this.exitFullscreen();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/authoringTool/iframe/pdfViewer/index.js